import { useContext } from "react";
import { VerifyContext } from "../app/VerifyContext";
import HiringContactsPage from "../features/hiring-contacts/HiringContactsPage";

export default function HiringContactsRoute() {
  const { superAdmin } = useContext(VerifyContext);
  return <HiringContactsPage isAdmin={superAdmin} />;
}
